<template>
    <div class="login-container">
        <div class="forgot-password-panel">
            <div class="forgot-password-title">
                <span v-text="title"></span>
                <img src="../../../assets/images/x-icon-grey.svg" alt="X" @click="actionBackToLogin">
            </div>
            <div class="forgot-password-desc" v-html="description"></div>
            <password-input label="New password" :check-password="true" :same-passwords="samePasswords" ref="password"
                            @input="actionCheckPassword" @keyup.enter.native="actionSubmit"/>
            <password-input label="Repeat new password" :check-password="true" :same-passwords="samePasswords"
                            ref="repeatPassword" @input="actionCheckPassword" @keyup.enter.native="actionSubmit"/>
            <text-button label="Submit" :loading-state="loadingState" @click="actionSubmit"/>
            <need-you-help/>
        </div>
    </div>
</template>

<script>
    import PasswordInput from "../../../old/components/PasswordInput";
    import NeedYouHelp from "../../../old/layouts/NeedYouHelp";
    import TextButton from "../../../old/components/TextButton";
    import UrlMap from "../../../js/slug-to-url-map";

    export default {
        name: "ChangePassword",
        components: {PasswordInput, NeedYouHelp, TextButton},
        data() {
            return {
                loadingState: false,
                samePasswords: true,
            }
        },
        computed: {
            title() {
                return 'Enter a new password';
            },
            description() {
                return 'Enter a new password for your account.';
            },
        },
        methods: {
            goToTheDashboard: function () {
                /* Delay for setting cookies */
                setTimeout(() => {
                    this.$router.push(this.$enums.RoutePathEnum.DASHBOARD);
                }, 10);
            },
            redirectUserToTheOldAppOrDashboard: function () {
                this.loadingState = true;
                this.$api.authenticatedInit()
                    .then(({data}) => {
                        this.loadingState = true;

                        let access = data.user.accesses.filter(x => x.hasAccess === true);

                        if (access.length !== 1) {
                            this.goToTheDashboard();
                            return;
                        }

                        let appSlug = access[0].appSlug;
                        if (appSlug in UrlMap) {
                            window.location = UrlMap[appSlug];
                            return;
                        }
                        this.goToTheDashboard();
                    }).catch(() => {
                    this.goToTheDashboard();
                }).finally(() => {
                    this.loadingState = false;
                });
            },
            actionBackToLogin() {
                this.$router.push(this.$enums.RoutePathEnum.LOGIN);
            },
            actionCheckPassword() {
                let password = this.$refs.password ? this.$refs.password.value : '';
                let repeatPassword = this.$refs.repeatPassword ? this.$refs.repeatPassword.value : '';

                this.samePasswords = !(password.length > 0 && repeatPassword.length > 0 && password !== repeatPassword);
            },
            actionSubmit() {

                this.loadingState = true;
                let password = this.$refs.password.value ?? '';
                let repeatPassword = this.$refs.repeatPassword.value ?? '';

                this.$api.updateProfile({
                    data: {
                        changePassword: true,
                        password: password,
                        confirmPassword: repeatPassword,
                    }
                }).then(() => {
                    this.redirectUserToTheOldAppOrDashboard();
                }).finally(() => this.loadingState = false)
            }
        }
    }


</script>

<style scoped>

</style>
